import type { SubscriptionLine } from '../../types/constant/SubscriptionType';
import type { SubscriptionLineApiType } from '../../types/api/SubscriptionApiType';

/**
 * 一覧 API（getSubscriptions）の行を、buildSubscriptionProducts が期待する形に近づける。
 * sellingPlanId は一覧レスポンスに無いため空文字（サムネ表示専用の暫定）。
 */
export function mapListLineToApiLine(line: SubscriptionLine): SubscriptionLineApiType {
  return {
    variantId: line.variantId,
    variantImage: line.variantImage ?? '',
    sku: line.sku ?? '',
    quantity: line.quantity,
    currentPriceAmount: line.currentPriceAmount,
    lineId: line.lineId,
    sellingPlanId: '',
    productId: line.productId,
  };
}
